import { ActionTree } from 'vuex'
import { CacheState } from './types'
import { RootState } from '../../types'
export const actions: ActionTree<CacheState, RootState> = {
  clearCache (): void {
    // TODO: cache not implemented in website builder
  }
}
